import { render, staticRenderFns } from "./MobileAddressBlock.vue?vue&type=template&id=7aa76c4a&scoped=true&"
import script from "./MobileAddressBlock.vue?vue&type=script&lang=js&"
export * from "./MobileAddressBlock.vue?vue&type=script&lang=js&"
import style0 from "./MobileAddressBlock.vue?vue&type=style&index=0&id=7aa76c4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa76c4a",
  null
  
)

export default component.exports